import { RouterProvider } from "react-router-dom";
import { AppProviders } from "./AppProviders";
import { sellerRouter } from "./router";

export function App() {
  return (
    <AppProviders>
      <RouterProvider router={sellerRouter} />
    </AppProviders>
  );
}
